import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CreateUserPage from './pages/CreateUserPage';
import UpdateAccessPage from './pages/UpdateAccessPage';
import UserDetailsPage from './pages/UserDetailsPage';
import FannotatorFilesPage from './pages/FannotatorFilesPage';
import FannotatorAnnotationsPage from './pages/FannotatorAnnotationsPage';
import AiAnnotationsPage from './pages/AiAnnotationsPage';
import AiAnnotationCheckPage from './pages/AiAnnotationCheckPage';


function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />

          {/* Protected routes below could be wrapped in a RequireAuth component if needed */}
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/create-user" element={<CreateUserPage />} />
          <Route path="/update-access/:username" element={<UpdateAccessPage />} />
          <Route path="/user-details/:username" element={<UserDetailsPage />} />
          <Route path="/fannotator-files" element={<FannotatorFilesPage />} />
          <Route path="/fannotator-annotations/:filename" element={<FannotatorAnnotationsPage />} />
          <Route path="/ai-annotations" element={<AiAnnotationsPage />} />
          <Route path="/ai-annotation-check" element={<AiAnnotationCheckPage />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
